<template>
    <div class="m-2">
        <template v-if="attachToExistingAccount">
            <div class="row g-2 m-2 mb-3">
                <div class="form-floating">
                    <input v-model="email" type="email"
                           v-bind:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.email,
                                                    'is-valid': typeof errors.email === 'undefined' && wasValidated,
                                                }"
                           id="email" placeholder="Email"  name="email" >
                    <label for="email" class="form-label">Email van je account <span class="text-muted">*</span></label>
                    <div class="invalid-feedback">
                        {{ errors.email }}
                    </div>
                </div>
                <div :class="'m-1 mt-3 form-check ' + (!legal && submitted ? ' text-danger fw-bold' : '')">
                    <input v-model="legal" class="form-check-input" type="checkbox">
                    <small class="form-check-label">
                        Ik ben akkoord met de <a href="/legal/algemene-voorwaarden">Algemene voorwaarden</a> en <a href="/legal/privacy-policy">Privacy policy</a>
                    </small>
                </div>
            </div>
            <button @click.prevent="send" type="button" class="btn btn-primary w-100 btn btn-lg btn-primary" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <i v-if="!loading" :class="'fa-solid fa-chevron-right me-2 deze1'"></i> Word nu lid
            </button>
        </template>
        <a v-else class="btn btn-primary w-100 btn btn-lg btn-primary" href="/account/subscriptions/new">
            <i :class="'fa-solid fa-chevron-right me-2 deze2'"></i> Word nu lid
        </a>
    </div>
</template>

<script>

export default {
    components: {},

    props: {
        attachToExistingAccount: {default: false},
    },

    mixins: [],

    data: function () {
        return {
            loading: false,
            email: '',
            legal: false,
            submitted: false,
            errors: {},
            wasValidated: false,
        };
    },

    computed: {
        looptijd() {
            return localStorage.getItem('subscription_looptijd');
        },
        personalTraining() {
            return localStorage.getItem('subscription_personalTraining');
        },
        stokAchterDeDeur() {
            return localStorage.getItem('subscription_stokAchterDeDeur');
        },
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        send() {
            this.submitted = true;
            if(!this.legal) {
                return;
            }

            const vm = this;
            this.loading = true;
            this.errors = {};
            this.wasValidated = false;

            window.axios.post(process.env.MIX_API_URL + '/api/v1/subscription/attach', {
                email: this.email,
                looptijd: this.looptijd,
                personal_training: this.personalTraining,
                stok_achter_de_deur: this.stokAchterDeDeur,
            })
                .then(function (response) {
                    vm.wasValidated = true;
                    let paymentLink = response.data.data;
                    window.location.href = paymentLink;
                })
                .catch(function (error) {
                    vm.loading = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors[formName] = errorMessage;
                            });
                        })
                    }
                    vm.wasValidated = true;
                });
        },
    },

    watch: {
        //
    }
};
</script>
